export default __webpack_public_path__ + "static/media/codepenFinal.ec685757.gif";